import React from 'react';

import { Button } from '@infoods/lifebase-ui';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { observer } from 'mobx-react';

import { PageTitle } from '../../../../shared/components/ui-components';
import { goTo } from '../../../../shared/utils/angularUtils';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { useCoachSeatsValidation } from '../../../../payment';
import { useUserRoleLabel } from '../../../../shared/hooks/useUserRoleLabel';
import { COACH_LIST_MODE, CoachListMode } from '../NgzCoachList.settings';

type CoachListPageTitleProps = {
  listMode: CoachListMode;
};

const CoachListPageTitle = observer(({ listMode }: CoachListPageTitleProps) => {
  const { isSuperAdmin, paymentFlowType, getEntityId } = loggedInUserDataStore;
  const entityId = getEntityId();

  const { getForAgent } = useUserRoleLabel();

  const { handleAddCoachValidation } = useCoachSeatsValidation(entityId);

  const setupCoachPathConfig: Record<CoachListMode, string> = {
    [COACH_LIST_MODE.NUTRITION]: '/nutrition/coach-setup',
    [COACH_LIST_MODE.SCAN_IQ]: '/scan-iq/coach-setup',
  };

  const setupCoachPath = setupCoachPathConfig[listMode];

  const handleAddCoach = async () => {
    if (isSuperAdmin || !paymentFlowType.NEW_USER_FLOW_2024) {
      goTo(setupCoachPath);
    } else {
      handleAddCoachValidation(() => goTo(setupCoachPath));
    }
  };
  return (
    <PageTitle title={`${getForAgent()} List`}>
      <Button
        variant="contained"
        size="medium"
        startIcon={<AddRoundedIcon />}
        onClick={handleAddCoach}
      >
        Add a New {getForAgent()}
      </Button>
    </PageTitle>
  );
});

export { CoachListPageTitle };
